<template>
  <div id="boardView" class="statv_container statv_page_bg">
    <section class="statv_page_wrapper statv_wrapper">
      <h1 class="statv_page_title"> 공지 · 이벤트 </h1>
      <div class="board_body">
				<div class="board_no_data" v-if="boards.list.length == 0">
					<p> 검색 결과가 없습니다. </p>
				</div>
        <div class="board_tbl_wrapper" v-for="(board, idx) in boards.list" :key="`board_${idx}`">
          <div class="board_tbl" :class="{'expanded': board.expand, 'top_fix':board.top_fix}" 
            @click.prevent="board.expand = !board.expand">
            <div class="cell row1"> {{setType(board.board_type)}} </div>
            <h2 class="cell row2"> {{board.title}} </h2>
            <div class="cell row3"> {{board.created_at}} </div>
            <div class="cell row4 collapse_btn"></div>
          </div>
          <div class="board_tbl_expand" :class="{'expanded': board.expand}">
            <div class="board_contents" :class="{'reverse': board.bottom_img}">
							<div class="img_box">
											<img v-for="image in board.images" :key="image" :src="`${image}`" :alt="`image_${board.title}`"/>
							</div>
							<div class="text_box">
											<p v-html="board.content"></p>
							</div>	
            </div>
							<div class="board_contents_footer">
								<p class="board_contents_file_cnt" v-if="board.files.length !== 0"> {{`첨부파일 ${board.files.length}개`}} </p>
								<div class="board_contents_file" 
								v-for="file in board.files" :key="file"
								@click.prevent="downloadFile(file)"> 
								<div class="download_btn"></div> {{file}} </div>
							</div>
          </div>
				</div>
      </div>
				<div class="board_footer">
					<pagination ref="pagination" @pageChange="onPageChange" />
					<div class="search_group">
						<input v-model="keyword" @keyup.enter="onSearch"/>
						<button @click.prevent="onSearch">검색</button>
					</div>
			</div>
    </section>
  </div>
</template>
<script>
import Utils from "@/helpers/utils.js";
import moment from "moment";
import Pagination from "./Pagination"
import * as Store from '@/store/modules/board'

export default {
  name: "Board",
  components: {
		Pagination
  },
  data() {
    return {
			currentPage: 1,
			keyword: '',
			offset: 10,
			id: 0,
      isMobile: false
    }
	},
	watch: {
    displayLvl(n) {
      this.setDisplayPages()
    }
  },
  computed: {
    ...Store.mapState([ 'boards' ]),
  },
  created() {
		this.checkParams()
		this.refresh()
	},
  mounted() {
		this.isMobile = Utils.isMobile()
	},
	watch: {
		'$route'() {
			this.checkParams()
			this.init()
		}
	},
  methods: {
		...Store.mapActions([ 'getBoards','searchKeyword' ]),
		checkParams() {
			const { id = this.id, page = this.currentPage, keyword = this.keyword } =  this.$route.query
			this.id = Number(id)
			this.currentPage = Number(page)
			this.keyword = keyword
		},
		async init() {
			await this.getList()
			this.$refs.pagination.init({
        currentPage: this.currentPage,
				totalPage: this.boards.totalPage,
				pageSize: this.isMobile ? 5 : 10,
				offset: this.offset
      })
		},
		async getList() {
			await this.getBoards({
				'page': this.currentPage,
				'keyword': this.keyword,
				'limit': this.offset
			})
			if(this.id > 0) {
				this.boards.list.filter(o => o.id == this.id).map(v => v.expand = true)
			}
		},
		refresh( { page = this.currentPage, keyword = this.keyword, limit = this.offset, id = this.id } = {} ) {
			const query = { page, keyword, limit, id }
			this.$router.push({
				path: this.$route.path,
				query: query
			}).catch((e) => { this.init() })
		},
		onSearch() {
			this.keyword = this.keyword.trim()
			if(this.keyword != '') {
				this.refresh({
					'keyword': this.keyword,
					'page' : 1
				})		
			}
		},
		onPageChange(page) {
			this.refresh({
				'page': page
			})
		},
		setType(type) {
			if( type == 1 ) return "공지"
			if( type == 2 ) return "이벤트"
		},
		downloadFile(file) {
			this.$axios.get(`/api/board/download/${file}`, {responseType: 'blob'}).then(
			response => {
				console.log(response);
				if(_.isEqual(response.status, 200)) {
					const blob = new Blob([response.data])
					if (window.navigator && window.navigator.msSaveOrOpenBlob) {
						window.navigator.msSaveOrOpenBlob(blob, file);
					} else {
						const fileURL = (window.URL || window.webkitURL).createObjectURL(blob)
						const fileLink = document.createElement('a')

						fileLink.href = fileURL
						fileLink.setAttribute('download', file)
						document.body.appendChild(fileLink)
						fileLink.click()
					}
				}
      });
    }
  },
}
</script>
<style lang="less">
#boardView {
	.board_body {
		min-height: 460px;
		.board_no_data {
			width: 100%;
			height: 450px;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 17px;
			color: #8F8F8F;
			font-weight: 400;
			border-bottom: 1px solid rgba(143, 143, 143, 0.3);
		}
		.board_tbl_wrapper {
			.board_tbl {
				display: flex;
				align-items: center;
				justify-content: flex-start;
				border-bottom: 1px solid rgba(143, 143, 143, 0.3);
				margin: 0 15px;
				height: 45px;
        color: #8f8f8f;
				cursor: pointer;
				.cell {
					font-size: 17px;
					font-weight: 400;
					transform: skew(0.03deg);
					display: flex;
					align-items: center;
					justify-content: center;
					&.row1 {
						position: relative;
						padding: 0 30px;
						width: 50px;
						border-right: 2px solid #8F8F8F;
					}
					&.row2 {
						//TITLE
						margin: 0 25px;
						width: 740px;
						display: inline-block;
						white-space: nowrap;
						word-break: break-all;
						text-overflow:ellipsis;
						overflow: hidden;
						justify-content: flex-start;
					}
					&.row3 {
						//DATE 
						width: 100px;
						padding: 0 15px;
					}
					&.row4 {
						width: 12px;
						height: 10px;
					}
				}
				&.top_fix {
					.cell {
						font-weight: 900;
						color: #ff6400;
						&.row1 {
							border-right: 2px solid #ff6400;
						}
					}
					.collapse_btn {
						background-image: url("~@/assets/image/board/arrow_down.png");		
					}
					&.expanded {
						.collapse_btn {
							background-image: url("~@/assets/image/board/arrow_down.png");
              transform: rotate(180deg);
						}
					}
				}
				.collapse_btn {
					display: block;
					background-image: url("~@/assets/image/board/arrow_gray_down.png");
					background-size: contain;
					background-position: center;
					background-repeat: no-repeat;
				}
				&.expanded {
					.cell {
						&.row2 {
							white-space: normal;
						}
					}
					.collapse_btn {
						background-image: url("~@/assets/image/board/arrow_gray_up.png");
					}
				}
			}
			.board_tbl_expand {
				display: none;
				height: 100%;
				padding: 30px 150px;
				background-color: rgba(248, 248, 248, 0.5);
				&.expanded {
					display: flex;
					flex-flow: column wrap;
					border-bottom: 1px solid rgba(143, 143, 143, 0.3);
					.board_contents {
						display: flex;
						flex-direction: column;
						transform: skew(0.03deg);
						&.reverse {
							flex-direction: column-reverse;
						}
						.img_box {
							order:1;
							margin-bottom: 30px;
							> img {
								display: block;
								max-width: 100%;
								max-height: 20rem;
								margin: 0 auto;
							}
						}
						.text_box {
							order:2;
							font-weight: 400;
							font-size: 17px;
							word-break: break-all;
							color: #8F8F8F;
							margin-bottom: 30px;
							transform: skew(0.03deg);
							line-height: 2;
							a {
								color: #ff6400;
							}
						}
					}
					.board_contents_footer {
						.board_contents_file_cnt {
							font-size: 17px;
							color: #8F8F8F;
							font-weight: 400;
							padding-top: 30px;
							border-top: 1px solid rgba(143, 143, 143, 0.3);
						}
						.board_contents_file {
							align-self: baseline;
							display: flex;
							height: 100%;
							align-items: center; 
							font-size: 17px;
							font-weight: 600;
							margin: 5px 0;
							color: #8F8F8F;
							cursor: pointer;
							.download_btn {
								width: 0.5rem;
								height: 0.7rem;
								background-image: url("~@/assets/image/board/download_img.png");
								background-position: center;
								background-repeat: no-repeat;
								background-size: 100%;
								margin: 0.1rem;
							}
						}
					}
				}
			}
		}
	}
	.board_footer {
		width: 100%;
		display: flex;
		flex-flow: column wrap;
		align-items: center;
		justify-content: center;
		margin-top: 30px;
		.search_group {
			display: flex;
			flex-flow: row wrap;
			margin-top: 30px;
			font-weight: 900;
			> input {
				font-family: 'NanumSquare';
				width: 348px;
				height: 36px;
				padding-left: 10px;
				border: 1px solid #ff6400;
				color: #ff6400;
			}
			> button {
				font-family: 'NanumSquare';
				width: 82px;
				height: 40px;
				background-color: #ff6400;
				color: #ffffff;
				border: 1px solid #ff6400;
				cursor: pointer;
				font-size: 17px;
				font-weight: 900;
			}
		}
	}
}

.m #boardView {
  	.board_body {
		min-height: 600px;
		.board_no_data {
			height: 600px;
			font-size: 24px;
		}
		.board_tbl_wrapper {
			.board_tbl {
				height: 120px;
				margin: 0;
				.cell {
					font-size: 24px;
					transform: skew(0.5deg);
					&.row1 {
						width: 75px;
						padding: 0 10px;
					}
					&.row2 {
						//TITLE
						width: 400px;
						margin: 0 10px;
					}
					&.row3 {
						//DATE 
						width: 120px;
						padding: 0 10px;
						font-size: 20px;
					}
					&.row4 {
						width: 12px;
						height: 10px;
					}
				}
			}
			.board_tbl_expand {
				padding: 30px 24px;
				&.expanded {
					.board_contents {
						.text_box {
							font-size: 24px;
						}
					}
					.board_contents_footer {
						.board_contents_file_cnt {
							font-size: 24px;
						}
					}
				}
			}
		}
	}
	.board_footer {
		margin-top: 26px;
		padding-bottom: 160px;
		.board_page_group {	
			font-size: 32px;
		}
		.search_group {
			> input {
				width: 396px;
				height: 56px;
				font-size: 24px;
				transform: skew(0.03deg);
			}
			> button {
				width: 120px;
				height: auto;
				font-size: 30px;
				// transform: skew(0.03deg);
			}
		}
	}
}
</style>
